/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import {
	DateInputProps,
	DateInput as NativeDateInput,
} from '@mantine/dates';

// Icons
import { IconCalendarWeek } from '@tabler/icons-react';

// Styles
import dayjs from 'dayjs';
import classes from './DateInput.module.css';
import './style.css';

/* -------------------------------------------------------------------------- */
/*                                    Types                                   */
/* -------------------------------------------------------------------------- */

export type AppDateInputProps = DateInputProps;

/* -------------------------------------------------------------------------- */
/*                                   Component                                */
/* -------------------------------------------------------------------------- */

/**
 * Returns the properties for the specified day in the DatePicker calendar.
 * @param {Date} date - The date of the day for which to retrieve the properties.
 * @param {Date} value - The date of the day selected by the user.

 * @returns {Object} The properties of the specified day in the DatePicker calendar, including background style.
 */
export const getDayProps: any = (
	date: Date,
	value: Date
) => {
	if (
		dayjs(date).format('YYYY-MM-DD') ==
			dayjs().format('YYYY-MM-DD') &&
		dayjs(value).format('YYYY-MM-DD') !==
			dayjs().format('YYYY-MM-DD')
	) {
		return {
			style: {
				backgroundColor: '#F0F3F8',
			},
		};
	}

	return {};
};

/**
 * A styled wrapper around Mantine's DateInput component.
 *
 * Features:
 * - Custom CSS modules styling
 * - Bottom-end popover position
 * - Calendar icon on the left side
 *
 * @param {AppDateInputProps} props - Props forwarded to Mantine DateInput
 */
export const DateInput = (props: AppDateInputProps) => {
	/* ******************************* RENDERING ******************************* */
	return (
		<NativeDateInput
			valueFormat="DD/MM/YYYY"
			classNames={classes}
			popoverProps={{ position: 'bottom-end' }}
			getDayProps={(date) =>
				getDayProps(date, props.value)
			}
			leftSection={
				<IconCalendarWeek
					size={18}
					stroke={1.5}
					color="var(--mantine-color-igluTextSecondary-9)"
				/>
			}
			{...props}
		/>
	);
};
